export default "__VITE_ASSET__DbExqW8b__"